<template>
<div>
  <b-spinner v-if="!calls"></b-spinner>
  <div v-if="calls && !calls.length">No phone calls yet.</div>
  <b-table-simple v-if="calls && calls.length > 0">
    <b-thead>
      <b-tr>
        <b-th>Date</b-th>
        <b-th>Connector</b-th>
        <b-th>Status</b-th>
        <b-th>Note</b-th>
        <b-th>Duration</b-th>
        <b-th>Recording</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr v-for="call in calls" :key="call.id">
        <b-td>{{call.createdAt | moment('from')}}</b-td>
        <b-td>{{call.connector.name}}</b-td>
        <b-td>{{call.status}}</b-td>
        <b-td>{{call.note}}</b-td>
        <b-td>
          <span v-if="call.duration">{{call.duration}} seconds</span>
          <span v-if="!call.duration">-</span>
        </b-td>
        <b-td>
          <audio v-if="call.recordingUrl" controls :src="call.recordingUrl"></audio>
          <span v-if="!call.recordingUrl">-</span>
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</div>
</template>
<script>
import {
  ListCalls
} from '@/gql/members/Calls.gql';

export default {
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  apollo: {
    calls: {
      query: ListCalls,
      variables() {
        return {
          number: this.member.phone
        }
      }
    }
  }
}
</script>
